'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$36() {
  this.bgB = null;
  this.bgz = null;
  this.bgA = false;
  this.bgx = null;
  this.bgy = false;
  this.bgC = false;
  this.bgD = false;
  this.bgB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$36 as $c_Lpresto_PrestoRouter$$anon$36 };
$p = $c_Lpresto_PrestoRouter$$anon$36.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$36;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$36() {
}
export { $h_Lpresto_PrestoRouter$$anon$36 as $h_Lpresto_PrestoRouter$$anon$36 };
$h_Lpresto_PrestoRouter$$anon$36.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bgB;
});
$p.t = (function() {
  if ((!this.bgA)) {
    this.bgz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgA = true;
  }
  return this.bgz;
});
$p.ad = (function() {
  if ((!this.bgy)) {
    this.bgx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgy = true;
  }
  return this.bgx;
});
$p.v = (function() {
  if ((!this.bgD)) {
    this.bgC = false;
    this.bgD = true;
  }
  return this.bgC;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$36 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$36, "presto.PrestoRouter$$anon$36", ({
  Ob: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$36 as $d_Lpresto_PrestoRouter$$anon$36 };
//# sourceMappingURL=presto.-Presto-Router$$anon$36.js.map
